<template>
	<div class="pa-0 ma-0">
		<v-banner min-height="77" color="surface" class="d-flex align-center border-0 justify-center">  
			<template v-slot:default>
				<v-row>
					<v-col cols="12" class="text-center d-flex align-center justify-center">
						<v-icon small class="text-on-surface mr-2">$iconCalculator</v-icon>
						<h4 class="on-surface text-h4 font-weight-medium">Discover Your Retirement Tax Bill – Get Your Immediate, No-Cost Report!</h4>
					</v-col>
				</v-row>
			</template>
		</v-banner>
		<v-divider color="surface-darken-3"></v-divider>
		<v-sheet min-height="800px" id="leadGenHero" class="fill-height d-flex align-center justify-center" :style="heroBackgroundStyle">
			<v-container class="py-16">
				<v-row class="d-flex align-center justify-center">
					<v-col cols="10" md="6" :class="display.mdAndUp.value ? 'pr-16' : 'pr-0'">
						<h4 class="text-h4 text-white">Uncover Your Potential Retirement Tax Bill in 3 Easy Steps</h4>
						<h1 class="text-h2 font-weight-bold text-wrap text-white py-3 d-flex flex-column"> <span class="text-accent mr-3"> Prepare for Retirement Taxes: </span> Calculate, Evaluate, Act</h1>
						<h4 class="text-h4 text-white">Get a no-cost report of your potential liability.</h4>
					</v-col>
					<v-col cols="10" md="6">
						<v-sheet color="surface" min-height="600" class="pa-5">
							<CalculationForm
								ref="calculationForm"
								:formFocus="focusOnForm"
								:resultsUrl="this.outputUrl"
							></CalculationForm>            
						</v-sheet>
					</v-col>
				</v-row>
			</v-container>
		</v-sheet>
		<v-banner min-height="77" class="d-flex align-center justify-center bg-surface-light">  
			<template v-slot:default>
				<v-row>
					<v-col cols="12" class="text-center ">
						<h4 class="text-on-surface-light text-h4 font-weight-medium"> 
							No-Cost Report 
							<v-icon class="text-on-surface-light" large>mdi-circle-small</v-icon>
							Instant Results
							<v-icon class="text-on-surface-light" large>mdi-circle-small</v-icon>
							Privacy Protected
						</h4>
					</v-col>
				</v-row>
			</template>
		</v-banner>
		<v-sheet min-height="410px" class="fill-height d-flex align-center justify-center bg-background" >
			<v-container class="py-10">
				<v-row class="py-0">
					<v-col cols="12" md="3" class="text-center py-5">
						<v-icon class="constraint150by100 text-secondary pb-15">
							$iconComputer
						</v-icon>
						<h2 class="font-weight-medium text-h3 text-sm-h2 text-on-surface">Step 1:</h2>
						<h3 class="font-weight-light text-on-surface constraint text-body-1 text-sm-h5 text-md-h4 mt-3">Enter your information—takes less than 30 seconds</h3>
					</v-col>
					<v-spacer></v-spacer>
					<v-col cols="12" md="3" class="text-center py-5">
						<v-icon class="constraint150by100 text-secondary pb-15">$iconEnvelope</v-icon>
						<h2 class="font-weight-medium text-h3 text-sm-h2 text-on-surface">Step 2:</h2>
						<h3 class="font-weight-light text-on-surface constraint text-body-1 text-sm-h5 text-md-h4 mt-3">Receive your results and report and immediately</h3>

					</v-col>
					<v-spacer></v-spacer>
					<v-col cols="12" md="3" class="text-center py-5">
						<v-icon class="constraint150by70 text-secondary pb-15">$iconPercentage</v-icon>
						<h2 class="font-weight-medium text-h3 text-sm-h2 text-on-surface">Step 3:</h2>
						<h3 class="font-weight-light text-on-surface text-body-1 text-sm-h5 text-md-h4 mt-3">Discover an option to help address your tax liability </h3>

					</v-col>
				</v-row>
			</v-container>
		</v-sheet>
		<v-sheet min-height="460px" color="surface-light" class="fill-height d-flex align-center justify-center pa-5">
			<v-container>
				<v-row class="d-flex justify-center align-center">
					<v-col cols="12" md="6" class="text-left d-flex flex-column ga-6 py-5">
						<span class="d-flex flex-column ga-3">
							<h3 class="text-h3 font-weight-bold text-accent">Maximize Retirement Savings:</h3>
							<h3 class="text-h2 text-on-surface-light font-weight-light ">Uncover Potential Hidden Taxes!</h3>
						</span>
						<ul class="text-on-surface-light pl-0 ga-2 d-flex flex-column" style="list-style-type: none;">
							<li class="pb-3"> <v-icon class="text-on-surface-light">mdi-arrow-right</v-icon> Reveal your potential tax bill in 3 easy steps</li>
							<li class="pb-3"> <v-icon class="text-on-surface-light">mdi-arrow-right</v-icon> Get a NO COST tax report with our user-friendly calculator</li>
							<li class="pb-3"> <v-icon class="text-on-surface-light">mdi-arrow-right</v-icon> Explore tailored options to potentially minimize tax obligations</li>
							<li class="pb-3"> <v-icon class="text-on-surface-light">mdi-arrow-right</v-icon> Feel more confident about your goals and stay ahead</li>
						</ul>
					</v-col>
					<v-col cols="12" md="6" class="text-left">
						<iframe
							style="width: 100%; height: auto; min-height: 400px;"
							:src="videoEmbedUrl"
							frameborder="0"
							allow="autoplay; fullscreen; picture-in-picture"
							webkitallowfullscreen
							mozallowfullscreen
							allowfullscreen
						></iframe>
					</v-col>
				</v-row>
			</v-container>
		</v-sheet>
		<v-container fluid class="bg-background">
			<v-container>
				<v-sheet color="surface" class="my-10 pa-5">
					<v-container class=" fill-height">
						<v-row align="stretch" class="d-flex align-center stretch">
							<v-col cols="12" md="6" class="text-on-surface d-flex flex-grow-1 ga-4 flex-column justify-space-around">
								<h3 class="text-h6 text-sm-h5 text-md-h4 font-weight-light text-on-surface">
									Quickly Uncover your Potential
									Tax Burden in 3 Easy Steps
								</h3>
								<h1 class="text-h5 text-sm-h4 text-md-h3 font-weight-bold text-on-surface">Prepare for Retirement Taxes: Calculate, Evaluate, Act</h1>
								<h3 class="text-h6 text-sm-h5 text-md-h4 font-weight-light text-on-surface">
									Get an immediate report of your potential liability.
								</h3>
							</v-col>
							<v-col cols="12" md="6" class="text-on-surface text-center d-flex flex-grow-1 flex-column justify-space-around align-center">
								<v-btn @click="scrollToForm" :size="display.mdAndUp.value ? 'x-large' : 'large'" rounded="md" color="primary" dark class="text-body-2 text-sm-h6 text-md-h5 font-weight-bold btn-lowerCase px-10 mt-5"> 
									Get Your Report Now
								</v-btn>
								<h2 class="font-weight-medium text-h6 text-sm-h5 text-md-h4 mt-5">
									<div>No-Cost Report </div>
									<div>Instant Results <v-icon class="text-on-surface" x-large>mdi-circle-small</v-icon>  Privacy Protected</div>
								</h2>
								
							</v-col>
						</v-row>
					</v-container>
				</v-sheet>
			</v-container>
		</v-container>

		<!-- <div id="myCustomContainer"></div>
		<div ref="scriptContainer"></div> -->

	</div>
</template>
<script>
import { useDisplay } from 'vuetify'
import CalculationForm from "../components/FormLeadGen.vue";
import { useLeadGeneratorStore } from '@/stores/leadGenerator'
import { buildHeroBackgroundStyle } from '@/utils/heroBackground'
import { DEFAULT_EMBED_VIDEO_URL, getVideoEmbedInfo } from '@/utils/mediaEmbed'
import fallbackHeroImage from '@/assets/images/TTB_LPHeader_0921.webp'

export default {
    components: {
        CalculationForm,
    },
	setup() {
		const store = useLeadGeneratorStore()
		const display = useDisplay()
		return { display, store }
	},
    data: () => ({
        focusOnForm: false,
    }),
	computed: {
		outputUrl() {
			// Use /results for /embed, otherwise /analysis
			return this.$route.path === '/embed' ? '/results' : '/analysis';
		},
		heroBackgroundStyle() {
			return buildHeroBackgroundStyle(
				this.store.customization?.media,
				this.store.heroImageCacheBust,
				fallbackHeroImage
			)
		},
		videoEmbedUrl() {
			const source = this.store.customization?.media?.videoSource || 'vimeo'
			const savedUrl = this.store.customization?.media?.videoUrl || ''
			const selected = savedUrl || DEFAULT_EMBED_VIDEO_URL

			const info = getVideoEmbedInfo(selected, source)
			if (info.isValid) return info.embedUrl

			const fallbackInfo = getVideoEmbedInfo(DEFAULT_EMBED_VIDEO_URL, 'vimeo')
			return fallbackInfo.embedUrl || DEFAULT_EMBED_VIDEO_URL
		},
		
	},
	methods: {
		scrollToForm() {
			console.log("Scroll to form triggered");
			// Scroll to the top of the page
			window.scrollTo(0, 0);

			// Set focus on the CalculationForm component
			this.focusOnForm = true;

			// Use $nextTick to ensure DOM updates before focusing
			this.$nextTick(() => {
				const formComponent = this.$refs.calculationForm;
				if (formComponent && formComponent.focunOnForm) {
					formComponent.focunOnForm(); // Call the focus method in CalculationForm
				}
			});
		},
	},
	mounted() {
		// // Insert the script tag manually into a div rendered by v-html
		// setTimeout(() => {
		// 	const container = this.$refs.scriptContainer;
		// 	const script = document.createElement('script');
		// 	script.src = 'https://dev.retirementtaxbill.com/leadGenEmbed.js';
		// 	script.setAttribute('data-u', 'Y1dIdGNsdmpLZ3BaRVFDN2Vhc0JXUT09');
		// 	script.setAttribute('data-maxwidth', '100%');
		// 	script.setAttribute('data-maxheight', '100vh');
		// 	script.setAttribute('data-target-id', 'myCustomContainer');
		// 	container.appendChild(script);
		// }, 0);
	}
	
};
</script>
<style>
	#leadGenHero {
		background-size: cover;
		background-position: center;
	}
</style>